import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Button from "../Button/Button";
import "./matching-assistance-modal-content.scss";
import { Typography } from "src/latest/src/components";
import { useSelector } from "react-redux";

type Props = {
    onContinue?: (concerns: string) => void;
    onGoBack: () => void;
};

export default function MatchingAssistanceModalContent({
    onContinue,
    onGoBack,
}: Props) {
    const [concerns, setConcerns] = useState("");
    const { loading } = useSelector((state: any) => state?.questionnaireData?.currentConfig);

    const editConcernsContent = (e: any) => {
        setConcerns(e.target.value.trimStart());
    };

    const handleContinueClick = () => {
        if (onContinue) {
            onContinue(concerns?.trim());
        }
    };
    
    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <div>
                <Typography variant="size-18" className="p-3">
                    We're excited to help you find a great match! To get
                    started, let's finish
                    <i>
                        <strong> creating your account.</strong>
                    </i>
                </Typography>
            </div>

            <div className="concerns-container">
                <div className="mt-3 mb-3">
                    <Typography>Availability and Concerns</Typography>
                </div>
                <textarea
                    className="text-area"
                    rows={4}
                    maxLength={500}
                    placeholder="Please provide us with the days of the week and windows of time when you are available. You can also share what you're looking for help with and any additional preferences."
                    value={concerns}
                    onChange={editConcernsContent}
                />
            </div>
            <Button
                variant={"primary"}
                textSize="size-18"
                textWeight="bold"
                label={"Continue"}
                onClick={handleContinueClick}
                className={`px-5 py-3 d-block mx-auto`}
                disabled={!concerns.length}
                isProcessing={loading}
            />

            <div className="go-back-button" onClick={() => onGoBack()}>
                <Typography color="color-26" variant="size-14" weight="bold">
                    <FontAwesomeIcon icon={faArrowLeft} /> Go Back
                </Typography>
            </div>
        </div>
    );
}
